import { useTranslation } from "react-i18next"
import { InfoFormLabelProps } from "./types"
import { FormLabel, Icon, Tooltip } from "@oysterhr/ui"
import { IconWithTooltip } from "@oysterhr/feature-components"
import { IntegrationBadge } from "~/app/components/integrations/IntegrationBadge"
import classNames from "classnames"

const ManualEditBlockedIndicator = () => {
  const { t } = useTranslation("Form")
  return (
    <Tooltip placement="right" value={t("lockedReason")}>
      <Icon name="Lock" className="ml-2" size="sm" />
    </Tooltip>
  )
}

export const InfoFormLabel = ({
  htmlFor,
  label,
  isOptional = false,
  manualEditBlocked = false,
  assistiveText,
  isPushedField,
  infoTooltip,
  disabled,
  className,
  endAdornment,
  isContractField = false,
}: InfoFormLabelProps) => {
  const { t } = useTranslation("Form")

  return (
    <FormLabel
      data-testid={htmlFor ? `${htmlFor}-label` : undefined}
      htmlFor={htmlFor}
      label={label}
      assistiveText={assistiveText}
      className={classNames(className, {
        "text-gray-300": disabled,
      })}
      isOptional={isOptional}
      endAdornment={
        <div className="flex items-center">
          {infoTooltip && (
            <IconWithTooltip unsafe_isValueInnerHTML value={infoTooltip} icon="InfoCircle" />
          )}
          {manualEditBlocked && <ManualEditBlockedIndicator />}
          {isPushedField && <IntegrationBadge isPullField={false} />}
          {isContractField &&
            (disabled ? (
              <Icon data-testid="agreement-generated-icon" name="FileText" />
            ) : (
              <IconWithTooltip
                iconTestId="agreement-generated-icon"
                value={t("contractTooltip.default")}
                icon="FileText"
              />
            ))}
          {endAdornment}
        </div>
      }
    />
  )
}
